import './App.css'
import MapContainer from './components/MapContainer'

function App() {
  return (
    <div className="app-container">
      <MapContainer />
    </div>
  )
}

export default App
